import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  flex-basis: 100%;
  width: 100%;
`;

export const Form = styled.form``;